import { Native, useAuthentication } from '@givebacks/api';
import { IfFeatureState_Core, usePlatformService } from 'core';
import { PagesUrl } from 'core/Utils';
import { useNavigate } from 'react-router-dom';
import { Divider, NavLink, Stack } from 'ui';
import { IconEarn, IconHome, IconReceipt, IconSearch, IconUser, IconWallet } from 'ui/Icons';

import classes from './MobileMenuLinks.module.css';

const AuthenticatedMenuLinks = () => {
  const Platform = usePlatformService();
  const { logOut } = useAuthentication();

  const navigate = useNavigate();

  return (
    <Stack gap={4} p="sm">
      <NavLink
        label="Profile"
        onClick={() => {
          navigate(PagesUrl.PROFILE);
        }}
        classNames={{ root: classes.authenticatedLink, label: classes.label }}
      />
      <NavLink
        label="Settings"
        onClick={() => {
          navigate(PagesUrl.SETTINGS);
        }}
        classNames={{ root: classes.authenticatedLink, label: classes.label }}
      />
      {Platform.isNative && (
        <NavLink
          label="Notifications"
          onClick={() => {
            Native.postMessage('Notifications');
          }}
          classNames={{ root: classes.authenticatedLink, label: classes.label }}
        />
      )}
      <NavLink
        label="FAQ"
        component="a"
        href="https://www.givebacks.com/faq"
        target="_blank"
        classNames={{ root: classes.authenticatedLink, label: classes.label }}
        onClick={(e) => {
          if (Native.WebView) {
            e.preventDefault();
            Native.postURL('https://www.givebacks.com/faq');
          }
        }}
      />
      <NavLink
        label="Legal"
        component="a"
        href="https://www.givebacks.com/terms"
        target="_blank"
        classNames={{ root: classes.authenticatedLink, label: classes.label }}
        onClick={(e) => {
          if (Native.WebView) {
            e.preventDefault();
            Native.postURL('https://www.givebacks.com/terms');
          }
        }}
      />
      <NavLink
        label="Support"
        component="a"
        href="https://support.givebacks.com/hc/en-us/categories/24997887276439-The-Givebacks-App"
        target="_blank"
        classNames={{ root: classes.authenticatedLink, label: classes.label }}
        onClick={(e) => {
          if (Native.WebView) {
            e.preventDefault();
            Native.postURL(
              'https://support.givebacks.com/hc/en-us/categories/24997887276439-The-Givebacks-App'
            );
          }
        }}
      />
      <Divider />
      <NavLink label="Log Out" classNames={classes} onClick={() => logOut()} />
    </Stack>
  );
};

const MobileMenuLinks = () => {
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();

  return (
    <Stack gap={4}>
      <NavLink
        label={'Home'}
        leftSection={<IconHome />}
        classNames={classes}
        onClick={() => {
          navigate('home');
        }}
      />

      <IfFeatureState_Core featureId="user.studentFees">
        <NavLink
          label={'Fees'}
          leftSection={<IconReceipt />}
          classNames={classes}
          onClick={() => {
            navigate('/student-fees');
          }}
        />
      </IfFeatureState_Core>

      <NavLink
        label={'Search'}
        leftSection={<IconSearch />}
        classNames={classes}
        onClick={() => {
          navigate('causes');
        }}
      />

      <NavLink
        label={'Earn'}
        leftSection={<IconEarn />}
        classNames={classes}
        onClick={() => {
          navigate('earn');
        }}
      />

      {isAuthenticated && (
        <IfFeatureState_Core
          featureId="user.account_page"
          fallBack={
            <NavLink
              label="Wallet"
              leftSection={<IconWallet />}
              classNames={classes}
              onClick={() => {
                navigate(PagesUrl.WALLET);
              }}
            />
          }
        >
          <NavLink
            label="Account"
            leftSection={<IconUser />}
            classNames={classes}
            onClick={() => {
              navigate(PagesUrl.ACCOUNT);
            }}
          />
        </IfFeatureState_Core>
      )}
    </Stack>
  );
};

export { AuthenticatedMenuLinks, MobileMenuLinks };
